import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useGridContext } from './gridContext';
import { toggleAdvancedSearch } from '../state/gridActions';
import { isAdvancedSearchOpen } from '../state/gridSelectors';
import ClickableText from 'spark-ui/ui-kitchen/ingredients/spices/text/ClickableText';
import { initialize, reset } from 'redux-form';

const ToggleText = styled(ClickableText)`
    font-size: 0.8em;
`;

const AdvancedSearchContainer = styled.div`margin: 1em 0;`;

export const AdvancedSearchToggle = () => {
	const gridName = useGridContext();
	const dispatch = useDispatch();
	const advancedSearchOpen = useSelector(state => isAdvancedSearchOpen(state, gridName));

	const handleToggle = () => {
		if (gridName === 'safetyAdminGrid' || gridName === 'safetyletterRecipient') {
			dispatch(toggleAdvancedSearch(gridName));
			dispatch(initialize(`${gridName}_advancedSearch`, { searchParam: '', status: '' }));
			dispatch(reset(`${gridName}_advancedSearch`));
		} else {
			dispatch(toggleAdvancedSearch(gridName));
		}
	};

	return (
		<ToggleText onClick={handleToggle}>
			{advancedSearchOpen ? 'Hide Advanced Search' : 'Advanced Search'}
		</ToggleText>
	);
};

export const AdvancedSearchSection = ({ children }) => {
	const gridName = useGridContext();
	const advancedSearchOpen = useSelector(state => isAdvancedSearchOpen(state, gridName));

	return advancedSearchOpen ? <AdvancedSearchContainer>{children}</AdvancedSearchContainer> : null;
};
